import React from 'react'

import './styles.scss'

const baseClass = 'image-cropper-wrapper'

const ImageCropperWrapper = ({ isOpen, children }) => isOpen && <div className={baseClass}>{children}</div>

export default ImageCropperWrapper
